import { Pipe, PipeTransform } from '@angular/core';
import { InstallerTeamLead, isInstallerLead, User } from '~gc/domains/users/user/user.model';

@Pipe({ name: 'isInstallerTeamLead' })
export class IsInstallerTeamLeadPipe implements PipeTransform {
  transform(user?: User | InstallerTeamLead): user is InstallerTeamLead {
    return isInstallerLead(user);
  }
}
